import React, { useEffect } from 'react';
import 'tslib';
import '../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import '@emotion/react';
import 'lodash.get';
import '@compono/ui-theme';
import 'deepmerge';
import '@emotion/is-prop-valid';
import { useUpdateEffect } from '../hooks/useUpdateEffect/index.js';
import { useDropdownMachine } from './useDropdownMachine.js';

var useDropdown = function (props) {
    if (props === void 0) { props = {}; }
    var disabled = props.disabled, defaultIsOpen = props.defaultIsOpen, onDismiss = props.onDismiss, _a = props.contentRef, contentRef = _a === void 0 ? React.useRef(null) : _a, _b = props.popoverRef, popoverRef = _b === void 0 ? React.useRef(null) : _b, _c = props.triggerRef, triggerRef = _c === void 0 ? React.useRef(null) : _c, _d = props.anchorRef, anchorRef = _d === void 0 ? React.useRef(null) : _d;
    var _e = useDropdownMachine({ disabled: disabled }), keyDownHandler = _e.keyDownHandler, isOpen = _e.isOpen, setIsOpen = _e.setIsOpen, toggleIsOpen = _e.toggleIsOpen;
    var dropdownRef = React.useRef(null);
    var handleGlobalClick = function (e) {
        var _a, _b;
        if (isOpen &&
            !((_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) &&
            !((_b = contentRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target))) {
            setIsOpen(false);
        }
    };
    useEffect(function () {
        document.addEventListener("mousedown", handleGlobalClick);
        return function () {
            document.removeEventListener("mousedown", handleGlobalClick);
        };
    }, [handleGlobalClick]);
    useEffect(function () {
        if (defaultIsOpen) {
            setIsOpen(true);
            setTimeout(function () {
                var _a;
                (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            });
        }
    }, []);
    useUpdateEffect(function () {
        !isOpen && (onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss());
    }, [isOpen]);
    return {
        contentRef: contentRef,
        disabled: disabled,
        dropdownRef: dropdownRef,
        popoverRef: popoverRef,
        triggerRef: triggerRef,
        anchorRef: anchorRef,
        keyDownHandler: keyDownHandler,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        toggleIsOpen: toggleIsOpen,
    };
};

export { useDropdown };
//# sourceMappingURL=useDropdown.js.map
